import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"preload\":true,\"fallback\":[\"system-ui\",\"Helvetica Neue\",\"Arial\",\"sans-serif\"],\"adjustFontFallback\":true,\"variable\":\"--font-inter\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/app/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/components/HotjarAnalytics.js");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/src/app/components/SessionProvider.js");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
